import { InjectionToken } from '@angular/core';
import { Action, ActionReducerMap, createSelector } from '@ngrx/store';
import * as fromAuth from './auth/reducers/auth.reducer';
import * as fromCancellation from './cancellation/reducers/cancellation.reducer';
import * as fromDashboard from './dashboard/reducers/dashboard.reducer';
import * as fromLayout from './layout/reducers/layout.reducer';
import * as fromSearchResult from './search-result/reducers/pnr.reducer';
import * as fromSpecialRequest from './special-requests/reducers/special-requests.reducer';
import * as fromVoluntaryChange from './voluntary-change/reducers/voluntary-change.reducer';
import * as fromInvoluntaryChange from './involuntary-change/reducers/involuntary-change.reducer';
import * as fromReissue from './reissue/reducers/reissue.reducer';
import * as fromIntegrationsModel from './integrations/store/models/integrations-state.model';
import * as fromIntegrationsReducer from './integrations/store/reducers/integrations.reducer';
import * as fromReRoute from './re-route/store/reducers/re-route.reducer';
import * as fromSettings from './settings/reducer/settings.reducer';

export interface State {
  auth: fromAuth.AuthState;
  cancellation: fromCancellation.CancellationState;
  dashboard: fromDashboard.DashboardState;
  layout: fromLayout.LayoutState;
  searchResult: fromSearchResult.PnrState;
  specialRequest: fromSpecialRequest.SpecialRequestState;
  voluntaryChanges: fromVoluntaryChange.VoluntaryChangeState;
  involuntaryChanges: fromInvoluntaryChange.InvoluntaryChangeState;
  integrations: fromIntegrationsModel.IntegrationsState;
  reissue: fromReissue.ReissueState;
  reRoute: fromReRoute.ReRouteState;
  settings: fromSettings.SettingsState;
}

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers', {
  factory: () => ({
    auth: fromAuth.reducer,
    cancellation: fromCancellation.reducer,
    dashboard: fromDashboard.reducer,
    layout: fromLayout.reducer,
    searchResult: fromSearchResult.PnrReducer,
    specialRequest: fromSpecialRequest.reducer,
    voluntaryChanges: fromVoluntaryChange.reducer,
    involuntaryChanges: fromInvoluntaryChange.reducer,
    integrations: fromIntegrationsReducer.reducer,
    reissue: fromReissue.reducer,
    reRoute: fromReRoute.reducer,
    settings: fromSettings.reducer
  })
});
